/* @flow weak */
import { combineReducers } from 'redux'

import app from 'data/app/reducer'
import auth from 'data/auth/reducer'
import config from 'data/config/reducer'
import contactUser from 'data/contactUser/reducer'
import dependencies from 'data/dependencies'
import device from 'data/device/reducer'
import channels from 'data/channels'
import intl from 'data/intl/reducer'
import invites from 'data/invites'
import medias from 'data/medias'
import notes from 'data/notes/reducer'
import notesHistory from 'data/notesHistory'
import organizations from 'data/organizations'
import ui from 'data/ui'
import pagination from 'data/graphql/pagination'
import publicUI from 'data/publicUI'
import search from 'data/search'
import threads from 'data/threads/reducer'
import users from 'data/users'
import { makeReducer } from './graphql'

export function getRootReducer() {
  return combineReducers({
    data: makeReducer(),
    app,
    auth,
    contactUser,
    config,
    dependencies,
    device,
    medias,
    channels,
    intl,
    invites,
    notes,
    notesHistory,
    organizations,
    pagination,
    publicUI,
    search,
    ui,
    users,
    threads,
  })
}

const configureReducer = config => {
  return getRootReducer()
}

export default configureReducer
